import { ILogger } from '@bloomays-lib/types.shared';
import { ApolloClientConfig } from '@bloomays-lib/common.auth/browser';
const { VITE_BLOOMERS_API, VITE_TALENTS_API } = import.meta.env;

export const getApolloConfig = (logger: ILogger): ApolloClientConfig => {
  return {
    apiUrls: {
      bloomers: VITE_BLOOMERS_API,
      talents: VITE_TALENTS_API,
    },
    logger,
    typePolicies: {
      GqlJobFunnel: { keyFields: ['id'] },
    },
  };
};
